<template>
    <!--
    To enable Drag&Drop we have to prevent default dragenter and dragover event.
    Dragover itentionally does not have defined callback.
    @see https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Drag_operations#specifying_drop_targets
    -->
    <label
        for="audio-file-input"
        class="audio-file-form"
        @dragover.stop.prevent=""
        @dragenter.stop.prevent="onDragEnter"
        @drop.stop.prevent="onDrop"
    >
        <div class="form-container">
            <audio-file-input
                id="audio-file-input"
                class="form-input"
                @change="onInputChange"
            />
            <i class="far fa-cloud-upload form-icon" />
            <span class="form-label">Upload audio file</span>
        </div>

        <transition name="fade">
            <div
                v-if="showOverlay"
                class="form-overlay"
                @dragleave.stop.prevent="onDragLeave"
            >
                Drop your file here
            </div>
        </transition>
    </label>
</template>
<script>
import AudioFileInput from './AudioFileInput';

export default {
    components: {
        AudioFileInput,
    },

    data: () => ({
        showOverlay: false,
    }),

    methods: {
        /**
         * Handles drag enter event.
         *
         * @param  {Event} event Event object.
         */
        onDragEnter(event) {
            this.showOverlay = true;
        },

        /**
         * Handles drag leave event.
         *
         * @param  {Event} event Event object.
         */
        onDragLeave(event) {
            this.showOverlay = false;
        },

        /**
         * Handles drop event.
         *
         * @param  {Event} event Event object.
         */
        onDrop(event) {
            this.showOverlay = false;

            this.$emit('submit', event.dataTransfer.files[0]);
        },

        /**
         * Handles change event on input.
         *
         * @param  {File} file Selected file.
         */
        onInputChange(file) {
            this.$emit('submit', file);
        },
    },
};
</script>
